module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/covid19/sp/icon_app-435c0fe830b1a399ac02ada7323b0424.png";